<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Ponto de Apoio | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>
        </div>

        <div class="box-body" v-if="loaded">
          <div class="form-group col-12 col-md-6">
            <label for="cd_ponto_apoio">Código: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.cd_ponto_apoio }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="descricao">Descrição: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.status_desc }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="cnpj">CNPJ: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.cnpj }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="cnpj">Horário atendimento: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.horario_atend_ini }} às {{ registro.horario_atend_fim }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="raio_atuacao">Raio de atuação (KM): &nbsp;&nbsp;&nbsp;</label>
            {{ registro.raio_atuacao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="cnpj">Horário indisponível: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.horario_indisponivel_ini ? `${registro.horario_indisponivel_ini} às ${registro.horario_indisponivel_fim}` : '-' }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="min_horas_agendamento">Horas antecedência p/ agendamento: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.min_horas_agendamento }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="idc_agenda_hora">Habilitar seleção de horário: &nbsp;&nbsp;&nbsp;</label>
            <span class="label" v-bind:class="{
              'label-success': registro.idc_agenda_hora,
              'label-warning': !registro.idc_agenda_hora,
            }">{{ registro.idc_agenda_hora ? 'Sim' : 'Não' }}</span>
          </div>
          <div class="form-group col-12 col-md-12">
            <label for="dt_inicio_operacao">Data de início de operação: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.dt_inicio_operacao}}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="capacidade_atend_hora">Capacidade atendimento de cada técnico/{{ registro.idc_agenda_hora ? 'hora' : 'dia' }}: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.capacidade_atend_hora }}
          </div>
          <div class="form-group col-12 col-md-12">
            <label for="telefone">Telefone: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.telefone }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_cep">CEP: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_cep }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_logradouro">Logradouro: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_logradouro }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_numero">Número: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_numero }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_complemento">Complemento: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_complemento }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_bairro">Bairro: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_bairro }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_cidade">Cidade: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_cidade }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_uf">UF: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_uf }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_pais">País: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.pais.descricao }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_latitude">Latitude: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_latitude }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="end_longitude">Longitude: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.end_longitude }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>

      <br/>

      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Horários de Atendimento</h3>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="form-group col-3 col-md-3"><b>Dia</b></div>
            <div class="form-group col-2 col-md-2 center"><b>Técnicos disponíveis</b></div>
            <div class="form-group col-2 col-md-2 center"><b>Horário atendimento</b></div>
            <div class="form-group col-2 col-md-2 center"><b>Horário indisponível</b></div>
            <div class="form-group col-2 col-md-2 center"><b>Dia indisponível</b></div>
            <div class="form-group col-1 col-md-1"></div>
          </div>
          <div class="row" v-for="item in registro.horarios" v-bind:key="item.dia_semana">
            <div class="form-group col-3 col-md-3">{{ item.dia_semana_desc }}</div>
            <div class="form-group col-2 col-md-2 center">{{ !item.indisponivel ? item.num_atend_disponivel : '-' }}</div>
            <div class="form-group col-2 col-md-2 center">{{ item.horario_atend_ini && !item.indisponivel ? `${item.horario_atend_ini} às ${item.horario_atend_fim}` : '-' }}</div>
            <div class="form-group col-2 col-md-2 center">{{ item.horario_indisponivel_ini && !item.indisponivel ? `${item.horario_indisponivel_ini} às ${item.horario_indisponivel_fim}` : '-' }}</div>
            <div class="form-group col-2 col-md-2">
              <span class="label center_span" v-bind:class="{
                'label-success': !item.indisponivel,
                'label-warning': item.indisponivel,
              }">{{ item.indisponivel ? 'Sim' : 'Não' }}</span>
            </div>
            <div class="form-group col-1 col-md-1 center_div">
              <div class="btn-group">
                <a @click="editarHorario(item.dia_semana)" class="btn btn-xs btn-warning legitRipple" data-tooltip="Editar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-pencil"></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br/>

      <div class="box box-primary">
        <div class="box-header">
          <i class="fas fa-clipboard"></i>
          <h3 class="box-title">Equipamentos</h3>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="form-group col-4 col-md-4 col-sm-4 col-xs-4"><b>Código</b></div>
            <div class="form-group col-4 col-md-4 col-sm-4 col-xs-4"><b>Player</b></div>
            <div class="form-group col-4 col-md-4 col-sm-4 col-xs-4"><b>Status</b></div>
          </div>
          <div class="row" v-for="item in equipamentos" v-bind:key="item.cd_equipamento">
            <div class="form-group col-4 col-md-4 col-sm-4 col-xs-4">{{ item.cd_equipamento }}</div>
            <div class="form-group col-4 col-md-4 col-sm-4 col-xs-4">{{ item.cd_player }}</div>
            <div class="form-group col-4 col-md-4 col-sm-4 col-xs-4">
              <span class="label label-info">{{ item.status_desc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal name="modal-horario" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-horario')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">Horário de atendimento</h3>
        </div>
        <div class="modal-body">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">{{ errorMessageModal }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-12">
              <label>Dia: </label> {{ horario_editar.dia_semana_desc }}
            </div>

            <div class="form-group col-12 col-md-12">
              <label for="horario_atend_ini">Horário atendimento <sup class="text-danger">* </sup></label>
              <br/>
              <select
                id="horario_atend_ini"
                v-model="horario_editar.horario_atend_ini"
                class="form-control combo-hora" v-bind:class="{ 'box-input-required': errors.horario_atend }"
                :disabled="horario_editar.indisponivel"
              >
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select> &nbsp;&nbsp; às &nbsp;&nbsp;
              <select
                id="horario_atend_fim"
                v-model="horario_editar.horario_atend_fim"
                class="form-control combo-hora" v-bind:class="{ 'box-input-required': errors.horario_atend }"
                :disabled="horario_editar.indisponivel"
              >
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select>
              <span v-show="errors.horario_atend != null" class="help-inline">{{ errors.horario_atend }}</span>
            </div>

            <div class="form-group col-12 col-md-12">
              <label for="horario_indisponivel_ini">Horário indisponível <sup class="text-danger">* </sup></label>
              <br/>
              <select id="horario_indisponivel_ini"
                v-model="horario_editar.horario_indisponivel_ini"
                class="form-control combo-hora"
                v-bind:class="{ 'box-input-required': errors.horario_indisponivel }"
                :disabled="horario_editar.indisponivel"
              >
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select> &nbsp;&nbsp; às &nbsp;&nbsp;
              <select
                id="horario_indisponivel_fim"
                v-model="horario_editar.horario_indisponivel_fim"
                class="form-control combo-hora"
                v-bind:class="{ 'box-input-required': errors.horario_indisponivel }"
                :disabled="horario_editar.indisponivel"
              >
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select>
              <span v-show="errors.horario_indisponivel != null" class="help-inline">{{ errors.horario_indisponivel }}</span>
            </div>

            <div class="form-group col-12 col-md-12">
              <label for="num_atend_disponivel">Técnicos disponíveis <sup class="text-danger">* </sup></label>
              <input
                id="num_atend_disponivel"
                v-model="horario_editar.num_atend_disponivel"
                v-mask="'###'"
                type="text"
                class="form-control input-number"
                v-bind:class="{ 'box-input-required': errors.num_atend_disponivel }"
                :disabled="horario_editar.indisponivel"
              />
              <span v-show="errors.num_atend_disponivel != null" class="help-inline">{{ errors.num_atend_disponivel }}</span>
            </div>

            <div class="form-group col-12 col-md-12">
              <label for="indisponivel">Indisponível <sup class="text-danger">* </sup></label>
              <br/>
              <toggle-button id="indisponivel" v-model="horario_editar.indisponivel"/>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-horario')">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="gravarHorario()">Gravar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import { formatCnpj } from '@brazilian-utils/formatters'
import Formatters from '../../helpers/Formatters'
import { onlyNumbers } from '../../helpers/numbers'
import PontoApoioActions from '../../actions/PontoApoioActions'
import EquipamentoActions from '../../actions/EquipamentoActions'
import moment from 'moment'

Vue.use(ToggleButton)

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errorMessageModal: '',
      errors: {},
      loaded: false,
      registro: {
        descricao: '',
        cnpj: '',
        telefone: '',
        end_cep: '',
        end_logradouro: '',
        end_numero: '',
        end_complemento: '',
        end_bairro: '',
        end_cidade: '',
        end_uf: '',
        end_pais: '',
        end_latitude: '',
        end_longitude: '',
        horario_atend_ini: '',
        horario_atend_fim: '',
        horario_indisponivel_ini: '',
        horario_indisponivel_fim: '',
        capacidade_atend_hora: '',
        raio_atuacao: '',
        min_horas_agendamento: '',
        idc_agenda_hora: '',
        status_desc: '',
        dt_inicio_operacao: '',
        pais: {
          descricao: ''
        }
      },
      equipamentos: [],
      horario_editar: {
        cd_ponto_apoio: '',
        dia_semana: '',
        dia_semana_desc: '',
        horario_atend_ini: '',
        horario_atend_fim: '',
        horario_indisponivel_ini: '',
        horario_indisponivel_fim: '',
        num_atend_disponivel: '',
        indisponivel: false
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    this.load()

    EquipamentoActions.listarPorPontoApoio(this.id)
      .then(res => {
        this.equipamentos = res
      })
  },
  methods: {
    voltar () {
      this.$router.push('/ponto-apoio')
    },
    load () {
      this.$parent.$parent.$data.showModalLoader = true

      PontoApoioActions.obterPontoApoio(this.id)
        .then(res => {
          if (res && res.descricao) {
            this.registro = res

            this.registro.cnpj = formatCnpj(this.registro.cnpj)
            this.registro.telefone = Formatters.formataNumeroTelefone(this.registro.telefone)
            this.registro.end_cep = Formatters.formataCep(this.registro.end_cep)

            this.registro.pais = this.registro.pais === null ? { descricao: null } : this.registro.pais

            if (this.registro.dt_inicio_operacao !== null) {
              this.registro.dt_inicio_operacao = moment.utc(this.registro.dt_inicio_operacao).format('DD/MM/YYYY')
            }
          } else {
            this.errorMessage = 'Registro não encontrado.'
          }

          this.loaded = true
          this.$parent.$parent.$data.showModalLoader = false
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Registro não encontrado.'
          this.$parent.$parent.$data.showModalLoader = false
        })
    },
    editar () {
      this.$router.push('/ponto-apoio/' + this.id + '/e')
    },
    editarHorario (dia) {
      this.errorMessageModal = ''
      this.errors = {}
      this.horario_editar = JSON.parse(JSON.stringify(this.registro.horarios.find(i => i.dia_semana === dia)))

      if (this.horario_editar.num_atend_disponivel === 0) {
        this.horario_editar.num_atend_disponivel = ''
      }

      this.$modal.show('modal-horario')
    },
    validationHorario () {
      this.errors = {}
      this.hasError = false

      if (!this.horario_editar.indisponivel) {
        if (!this.horario_editar.horario_atend_ini || !this.horario_editar.horario_atend_fim) {
          this.errors.horario_atend = 'Este campo deve ser preenchido.'
          this.hasError = true
        }

        if (this.horario_editar.horario_atend_ini && this.horario_editar.horario_atend_fim) {
          if (onlyNumbers(this.horario_editar.horario_atend_ini) > onlyNumbers(this.horario_editar.horario_atend_fim)) {
            this.errors.horario_atend = 'Horário inválido.'
            this.hasError = true
          }
        }

        if ((this.horario_editar.horario_indisponivel_ini && !this.horario_editar.horario_indisponivel_fim) ||
          (!this.horario_editar.horario_indisponivel_ini && this.horario_editar.horario_indisponivel_fim)) {
          this.errors.horario_indisponivel = 'Este campo deve ser preenchido.'
          this.hasError = true
        }

        if (this.horario_editar.horario_indisponivel_ini && this.horario_editar.horario_indisponivel_fim) {
          if (onlyNumbers(this.horario_editar.horario_indisponivel_ini) > onlyNumbers(this.horario_editar.horario_indisponivel_fim)) {
            this.errors.horario_indisponivel = 'Horário inválido.'
            this.hasError = true
          }
        }

        if (!this.horario_editar.num_atend_disponivel) {
          this.errors.num_atend_disponivel = 'Este campo deve ser preenchido.'
          this.hasError = true
        } else if (parseInt(this.horario_editar.num_atend_disponivel) === 0) {
          this.errors.num_atend_disponivel = 'Informe um valor maior que zero.'
          this.hasError = true
        }
      }
    },
    gravarHorario () {
      this.validationHorario()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        PontoApoioActions.gravarHorario(this.horario_editar)
          .then(response => {
            this.$parent.$parent.$data.showModalLoader = false
            this.load()
            this.$modal.hide('modal-horario')
          })
          .catch((error) => {
            console.log(error.message)
            this.errorMessageModal = 'Ocorreu um erro ao gravar o registro.'
            this.$parent.$parent.$data.showModalLoader = false
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/ponto-apoio/Detalhes.vue